<template>
  <div class="row p-0 my-3 blog-row">
    <div class="col-12 col-md-6 p-0 blog-col">
      <p style="font-size: 42px">{{ post.blogTitle }}</p>
      <div v-html="post.blogHTML" class="mb-4 html-section"></div>
      <router-link
        :to="{ name: 'SingleBlog', params: { blogid: this.post.blogID } }"
        style="font-size: 14px"
        >VIEW THE POST -></router-link
      >
    </div>
    <div class="col-12 col-md-6 p-0" v-bind:class="{ col2: number % 2 !== 0 }">
      <img :src="post.blogCoverPhoto" class="blog-img img-fluid" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["post", "number"],
  name: "blog",
};
</script>

<style>
.blog-col {
  order: 2;
  padding: 20px 100px 20px 100px !important;
}
@media (max-width: 450px) {
  .blog-col {
    order: 2;
    padding: 20px 50px 20px 50px !important;
  }
}
.html-section {
  font-size: 18px;
  max-height: 300px;
  overflow: hidden;
}
.col2 {
  order: 3;
}
.blog-row {
  align-items: center;
}
</style>